import { render, staticRenderFns } from "./SortSwitcher.vue?vue&type=template&id=0f4ba5fc&scoped=true&"
import script from "./SortSwitcher.vue?vue&type=script&lang=ts&"
export * from "./SortSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./SortSwitcher.vue?vue&type=style&index=0&id=0f4ba5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ba5fc",
  null
  
)

export default component.exports